import { FormEvent, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import toast, { Toaster } from "react-hot-toast";
import PageHeader from "../-components/PageHeader";
import { theadStyle } from "./NoticeForm";
import { RouteTypes, shortcut, toastErrorSyle } from "hooks/utils/util";
import ConsoleHrozontalHeadTable from "../-components/ConsolehorizontalHeadTable";
import { useDeleteConsoleBillInquiry } from "hooks/console/useDeleteConsoleBillInquiry";
import { BillInquiryDetailResponse, useGetConsoleBillInquiryDetail } from "hooks/console/useGetConsoleBillInquiryDetail";
import { usePostConsoleBillComment } from "hooks/console/usePostConsoleBillComment";
import { usePutConsoleBillComment } from "hooks/console/usePutConsoleBillComment";
import { useDeleteConsoleBillComment } from "hooks/console/useDeleteConsoleBillComment";
import Editor from "components/Editor";
import { usePutConsoleBillInquiry } from "hooks/console/usePutConsoleBillInquiry";
import ConfirmDialog from "components/popup/ConfirmDialog";
import Comment from "../-components/Comment";
import Seo from "components/Seo";

const initialForm = {
    flag: true,
    list_no: 0,
    bl_no: "",
    subject: "",
    contents: "",
    company: "",
    m_email: "",
    mobile: "",
    w_date: "",
    comment: [],
};

export default function ConsoleInvoicesEditDetail({ type }: { type: RouteTypes }) {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const idx = params.idx;
    const page = location.state?.page ?? "1";
    const [editMode, setEditMode] = useState(false);
    const { data, refetch } = useGetConsoleBillInquiryDetail({ category: type, list_no: idx ?? "" });
    const { mutate: deleteBillInquiry } = useDeleteConsoleBillInquiry();
    const { mutate: updateBillInquiry } = usePutConsoleBillInquiry();
    const { mutate: postComment } = usePostConsoleBillComment();
    const { mutate: updateComment } = usePutConsoleBillComment();
    const { mutate: deleteComment } = useDeleteConsoleBillComment();
    const [form, setForm] = useState<BillInquiryDetailResponse>(initialForm);
    const { 청구서수정및문의상세 } = shortcut(type, idx);

    // console.log("detail", data);

    useEffect(() => {
        if (data) {
            setForm(prev => ({
                ...prev,
                flag: data.flag,
                list_no: data.list_no,
                bl_no: data.bl_no,
                subject: data.subject,
                contents: data.contents,
                company: data.company,
                m_email: data.m_email,
                mobile: data.mobile,
                w_date: data.w_date,
                comment: data.comment,
            }));
        }
    }, [data]);

    const thead = [
        { title: "제목", key: "subject" },
        // { title: "작성일", key: "w_date" },
        { title: "운송장번호", key: "bl_no", thClassName: "whitespace-nowrap" },
        { title: "요청업체명", key: "company" },
        {
            title: "문의 및 요청사항",
            key: "contents",
            content: (value: string) => <div className="py-3" dangerouslySetInnerHTML={{ __html: value }} />,
        },
        { title: "비고", key: "m_email" },
        { title: "연락 드릴 번호", key: "mobile" },
    ];

    const handleDeleteInvoices = () => {
        deleteBillInquiry(
            { category: type, list_no: [Number(idx)] },
            {
                onSuccess: () => {
                    toast.success("성공적으로 삭제 되었습니다.");
                    navigate(-1);
                },
                onError: (error: any) => {
                    const message = error.message;
                    toast.error(message, toastErrorSyle);
                },
            },
        );
    };
    const update = () => setEditMode(true);

    const handleUpdateInvoicesDetail = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (idx) {
            updateBillInquiry(
                {
                    category: type,
                    list_no: idx,
                    bl_no: form.bl_no,
                    subject: form.subject,
                    contents: form.contents,
                    company: form.company,
                    m_email: form.m_email,
                    mobile: form.mobile,
                },
                {
                    onSuccess: () => {
                        toast.success("성공적으로 수정 되었습니다.");
                        // refetch();
                    },
                    onError: (error: any) => {
                        const message = error.message;
                        toast.error(message, toastErrorSyle);
                    },
                },
            );
        }
    };

    // 코멘트 등록
    const handlePostComment = (value: string, successCallback: () => void) => {
        if (value?.trim() === "") {
            toast.error("내용을 입력해주세요.", toastErrorSyle);
            return;
        }

        if (idx) {
            postComment(
                { category: type, list_no: idx, c_content: value },
                {
                    onSuccess: () => {
                        toast.success("성공적으로 등록 되었습니다.");
                        refetch();
                        successCallback();
                    },
                    onError: (error: any) => {
                        const message = error.message;
                        toast.error(message, toastErrorSyle);
                    },
                },
            );
        }
    };

    // 코멘트 삭제
    const handleDeleteComment = (cListNo: string) => {
        if (idx) {
            deleteComment(
                {
                    category: "morning",
                    list_no: Number(idx),
                    c_list_no: Number(cListNo),
                },
                {
                    onSuccess: () => {
                        toast.success("성공적으로 삭제 되었습니다.");
                        refetch();
                    },
                    onError: (error: any) => {
                        const message = error.message;
                        toast.error(message, toastErrorSyle);
                    },
                },
            );
        }
    };

    // 코멘트 수정
    const handleUpdateComment = (cListNo: string, content: string) => {
        if (idx) {
            updateComment(
                {
                    category: "morning",
                    list_no: idx,
                    c_list_no: cListNo,
                    c_content: content,
                },
                {
                    onSuccess: () => {
                        toast.success("성공적으로 수정 되었습니다.");
                        // refetch();
                        setEditMode(false);
                    },
                    onError: (error: any) => {
                        const message = error.message;
                        toast.error(message, toastErrorSyle);
                    },
                },
            );
        }
    };

    if (!idx) return <div>잘못된 접근입니다.</div>;

    return (
        <>
            <Seo type="console" pageTitle="청구서수정요청" />
            <div className="flex-1 flex flex-col overflow-hidden max-h-[100dvh]">
                <PageHeader category="고객서비스" title="청구서수정요청" linkTo={청구서수정및문의상세} />
                <div className="flex-1 bg-[#F7F6FB] flex overflow-hidden">
                    <div className="px-[40px] py-[28px] w-full overflow-auto">
                        {data ? (
                            <div className="bg-white rounded-[20px] py-[36px] px-[40px] w-full min-w-[800px]">
                                {editMode ? (
                                    <form onSubmit={handleUpdateInvoicesDetail}>
                                        <div className="mt-[8px] mb-[40px]">
                                            <ConsoleHrozontalHeadTable
                                                thead={[
                                                    {
                                                        title: "제목",
                                                        key: "subject",
                                                        tdClassName: twMerge(theadStyle, "text-[#666666] text-left"),
                                                        content: (row: string) => (
                                                            <div>
                                                                <input
                                                                    type="text"
                                                                    value={form.subject}
                                                                    onChange={e =>
                                                                        setForm(prev => ({
                                                                            ...prev,
                                                                            subject: e.target.value,
                                                                        }))
                                                                    }
                                                                    className="border rounded-[5px] px-2 py-1 w-full"
                                                                />
                                                            </div>
                                                        ),
                                                    },
                                                    {
                                                        title: "운송장번호",
                                                        key: "bl_no",
                                                        tdClassName: twMerge(theadStyle, "text-[#666666] text-left"),
                                                        content: (row: string) => (
                                                            <div>
                                                                <input
                                                                    type="text"
                                                                    value={form.bl_no}
                                                                    onChange={e =>
                                                                        setForm(prev => ({
                                                                            ...prev,
                                                                            bl_no: e.target.value,
                                                                        }))
                                                                    }
                                                                    className="border rounded-[5px] px-2 py-1 w-full"
                                                                />
                                                            </div>
                                                        ),
                                                    },
                                                    {
                                                        title: "운송장번호",
                                                        key: "bl_no",
                                                        tdClassName: twMerge(theadStyle, "text-[#666666] text-left"),
                                                        content: (row: string) => (
                                                            <div>
                                                                <input
                                                                    type="text"
                                                                    value={form.bl_no}
                                                                    onChange={e =>
                                                                        setForm(prev => ({
                                                                            ...prev,
                                                                            bl_no: e.target.value,
                                                                        }))
                                                                    }
                                                                    className="border rounded-[5px] px-2 py-1 w-full"
                                                                />
                                                            </div>
                                                        ),
                                                    },
                                                    {
                                                        title: "요청업체명",
                                                        key: "company",
                                                        tdClassName: twMerge(theadStyle, "text-[#666666] text-left"),
                                                        content: (row: string) => (
                                                            <div>
                                                                <input
                                                                    type="text"
                                                                    value={form.company}
                                                                    onChange={e =>
                                                                        setForm(prev => ({
                                                                            ...prev,
                                                                            company: e.target.value,
                                                                        }))
                                                                    }
                                                                    className="border rounded-[5px] px-2 py-1 w-full"
                                                                />
                                                            </div>
                                                        ),
                                                    },
                                                    {
                                                        title: "문의 및 요청사항",
                                                        key: "contents",
                                                        tdClassName: twMerge(theadStyle, "text-[#666666] text-left"),
                                                        content: (row: string) => (
                                                            <div id="bounds" className="py-1">
                                                                <Editor
                                                                    bounds="#bounds"
                                                                    value={form.contents}
                                                                    onChangeHandler={(val: string) =>
                                                                        setForm(prev => ({ ...prev, contents: val }))
                                                                    }
                                                                    className="[&_.ql-editor]:min-h-[350px] h-auto responsive650:[&_.ql-editor]:min-h-[150px]"
                                                                />
                                                            </div>
                                                        ),
                                                    },
                                                    {
                                                        title: "비고",
                                                        key: "m_email",
                                                        tdClassName: twMerge(theadStyle, "text-[#666666] text-left"),
                                                        content: (row: string) => (
                                                            <div className="flex items-center py-1">
                                                                <textarea
                                                                    value={form.m_email}
                                                                    onChange={e =>
                                                                        setForm(prev => ({
                                                                            ...prev,
                                                                            m_email: e.target.value,
                                                                        }))
                                                                    }
                                                                    className="border rounded-[5px] px-2 py-1 w-full"
                                                                />
                                                            </div>
                                                        ),
                                                    },
                                                    {
                                                        title: "연락 드릴 번호",
                                                        key: "mobile",
                                                        tdClassName: twMerge(theadStyle, "text-[#666666] text-left"),
                                                        content: (row: string) => (
                                                            <div>
                                                                <input
                                                                    type="text"
                                                                    value={form.mobile}
                                                                    onChange={e =>
                                                                        setForm(prev => ({
                                                                            ...prev,
                                                                            mobile: e.target.value,
                                                                        }))
                                                                    }
                                                                    className="border rounded-[5px] px-2 py-1 w-full"
                                                                />
                                                            </div>
                                                        ),
                                                    },
                                                ]}
                                                tbody={form}
                                            />

                                            <div className="flex justify-center gap-2 mt-5">
                                                <button className="bg-black text-white rounded-[5px] px-4 py-2">저장</button>
                                                <button
                                                    type="button"
                                                    className="bg-black text-white rounded-[5px] px-4 py-2"
                                                    onClick={() => setEditMode(false)}
                                                >
                                                    취소
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                ) : (
                                    <>
                                        <ConsoleHrozontalHeadTable thead={thead} tbody={form} />

                                        <div className="flex justify-center gap-x-[8px] mt-5">
                                            <button
                                                className="text-[#666666] text-[18px] bg-white rounded-[5px] border border-[#dddddd] px-[55px] py-[15px]"
                                                onClick={update}
                                            >
                                                수정
                                            </button>
                                            <ConfirmDialog
                                                title="요청 삭제"
                                                trigger={open => (
                                                    <button
                                                        type="button"
                                                        onClick={open}
                                                        className="text-[#666666] text-[18px] bg-white rounded-[5px] border border-[#dddddd] px-[55px] py-[15px]"
                                                    >
                                                        삭제
                                                    </button>
                                                )}
                                                handleConfirm={handleDeleteInvoices}
                                            />
                                            <button
                                                onClick={() =>
                                                    page ? navigate(`/${type}/customer/invoices-edit?page=${page}`) : navigate(-1)
                                                }
                                                className="text-white text-[18px] bg-[#4F46E5] rounded-[5px] border border-[#666666] px-[55px] py-[15px]"
                                            >
                                                목록
                                            </button>
                                        </div>

                                        <Comment
                                            commentData={form.comment}
                                            postComment={handlePostComment}
                                            updateComment={handleUpdateComment}
                                            deleteComment={handleDeleteComment}
                                        />
                                    </>
                                )}
                            </div>
                        ) : (
                            <div className="bg-white rounded-[20px] flex flex-col gap-5 items-center justify-center py-[100px]">
                                <p>결과가 없습니다.</p>
                                <button onClick={() => navigate(-1)} className="rounded-[8px] border px-5 py-2">
                                    뒤로가기
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Toaster position="bottom-center" reverseOrder={false} />
        </>
    );
}
